// Zdieľané dátumové helpery (V2, 0 fetch, 0 LLM). Extrahované z reminderText.js
// aby ich vedel reuse-núť aj briefing.js / taxDeadlines.js bez kopírovania.
// Telo výpočtov drží string-compare ISO; new Date() len ako default „dnes".
// ──────────────────────────────────────────────────────────────────────────

// Naformátuj ISO 'YYYY-MM-DD' na SK 'D. M. YYYY'. Ak vstup nie je validný, vráť ho ako-je.
export function fmtSkDate(iso) {
  if (!iso || typeof iso !== 'string') return '';
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  const [, y, mo, d] = m;
  return `${Number(d)}. ${Number(mo)}. ${y}`;
}

// Počet dní od epochy pre ISO 'YYYY-MM-DD' (UTC), bez timezone bugu.
// Parsujeme komponenty a počítame v UTC, takže letný/zimný čas to neovplyvní.
// Rozdiel dvoch výsledkov = počet dní medzi dátumami.
export function isoToUtcDays(iso) {
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const [, y, mo, d] = m;
  return Math.floor(Date.UTC(Number(y), Number(mo) - 1, Number(d)) / 86400000);
}

// True len ak `iso` je STRICT 'YYYY-MM-DD' a REÁLNY kalendárny dátum.
// DATE_RE shape sama nestačí: '2026-02-31' / '2026-13-01' prejdú regexom, ale
// nie sú reálne dni. Round-trip cez Date.UTC → keď sa komponenty nezhodujú
// (JS pretečie 2026-02-31 na marec), dátum je neplatný.
const STRICT_ISO_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
export function isValidIsoDate(iso) {
  const m = STRICT_ISO_RE.exec(String(iso));
  if (!m) return false;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  if (mo < 1 || mo > 12 || d < 1 || d > 31) return false;
  const dt = new Date(Date.UTC(y, mo - 1, d));
  return dt.getUTCFullYear() === y && dt.getUTCMonth() === mo - 1 && dt.getUTCDate() === d;
}

// Vráť dnešný dátum ako ISO 'YYYY-MM-DD' (lokálny deň).
export function todayIso(now = new Date()) {
  const y = now.getFullYear();
  const mo = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${mo}-${d}`;
}

// SK skloňovanie "deň/dni/dní".
export function dniWord(n) {
  if (n === 1) return 'deň';
  if (n >= 2 && n <= 4) return 'dni';
  return 'dní';
}

// Počet celých dní medzi dvoma ISO dátumami (b − a). Kladné = b je neskôr.
// null ak ktorýkoľvek vstup nie je validný ISO.
export function daysBetweenIso(aIso, bIso) {
  const a = isoToUtcDays(aIso);
  const b = isoToUtcDays(bIso);
  if (a == null || b == null) return null;
  return b - a;
}
